export function calculateAnswerLayout({ viewportWidth, viewportHeight, cardLengths }) {
  const lengths = cardLengths?.length ? cardLengths : [1];
  const margin = Math.max(14, Math.min(28, viewportWidth * .04));
  const availableWidth = Math.min(1080, viewportWidth - margin * 2);
  const availableHeight = Math.max(160, viewportHeight - margin * 2);
  const totalLength = Math.max(1, lengths.reduce((sum, length) => sum + length, 0));
  const areaSize = Math.sqrt((availableWidth * availableHeight * .62) / (totalLength + lengths.length * 2));
  const characterSize = clamp(areaSize * 1.08, 26, viewportWidth < 560 ? 38 : 52);
  const sideInset = clamp(viewportWidth * .065, margin, 96);
  const targetWidth = viewportWidth - sideInset * 2;
  const charsPerLine = Math.max(1, Math.floor(targetWidth / (characterSize * .93)));
  const estimatedRows = lengths.reduce((rows, length) => rows + Math.max(1, Math.ceil(length / charsPerLine)), 0);
  const estimatedHeight = Math.min(availableHeight, estimatedRows * characterSize + Math.max(0, lengths.length - 1) * 10);
  const topInset = clamp(viewportHeight * .14, margin + 18, 128);
  const left = sideInset;
  const top = clamp(topInset, margin, viewportHeight - margin - estimatedHeight);

  return { characterSize, targetWidth, estimatedHeight, left, top };
}

function clamp(value, min, max) {
  return Math.min(max, Math.max(min, value));
}
